import { z } from "zod";
import { EmailAddressSchema } from "./email.schemas.js";
import { E164PhoneNumberSchema } from "./phone.schemas.js";
import { EventParticipantIdPublicSchema } from "./branded-id.schemas.js";

export const DirectoryConnectionStatusValues = {
  NONE: "none",

  REQUESTED: "requested",

  INBOUND: "inbound",

  CONNECTED: "connected",

  IGNORED: "ignored",
} as const;

export type DirectoryConnectionStatusType =
  (typeof DirectoryConnectionStatusValues)[keyof typeof DirectoryConnectionStatusValues];

export const DirectoryConnectionStatus = {
  ...DirectoryConnectionStatusValues,
} as const;

// Populated only when connectionStatus === 'connected' (enforced in the use-case layer).
export const ProfileContactInfoSchema = z.object({
  email: EmailAddressSchema.nullable(),
  phone: E164PhoneNumberSchema.nullable(),
});

export type ProfileContactInfo = z.infer<typeof ProfileContactInfoSchema>;

// Contact info of the OTHER party — backend resolves which side, client never picks.
export const IntroContactInfoSchema = z.object({
  participantIdPublic: EventParticipantIdPublicSchema,
  contactInfo: ProfileContactInfoSchema,
});

export type IntroContactInfo = z.infer<typeof IntroContactInfoSchema>;
